export const countriesKeys = ['CO', 'CH', 'MX', 'BR', 'EC']